const locations = {
  toast: {
    error: {
      badResponse: '[localização] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Location] foi criado com sucesso',
      },
      edit: {},
      delete: {
        default: '[Location] excluído com sucesso',
      },
    },
  },
  headerButtons: {
    create: {
      createBtn: 'Criar',
    },

    import: 'Importar',
  },

  deleteModal: {
    header: 'Excluir Localizações',
    body: 'Você está prestes a excluir {{num}} locais.',
  },

  printoutsModal: {
    title: 'Exportação de PDF de impressões',
    description: 'Selecione o intervalo de datas (máximo de 31 dias)',
    maxRangeError: 'Selecione um intervalo de 31 dias ou menos',
    export: 'Exportar',
  },

  table: {
    filters: {
      type: 'Tipo',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
      printouts: 'Impressões',
    },
    moreActions: {
      showOnMap: 'Mostrar no mapa',
    },
    headers: {
      name: 'Nome',
      type: 'Tipo',
      address: 'Endereço',
      lat: 'Latitude',
      lon: 'Longitude',
      locationTypes: {
        location: 'Localização',
        inAndOut: 'Dentro e Fora',
        airport: 'Aeroporto',
        facility: 'Instalação',
      },
      wait: 'Aguarde',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createLocation: {
        title: 'Criar',
      },

      updateLocation: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    addressInformation: {
      title: 'Informação de endereço',
      name: 'Nome',
      type: 'Tipo',
      wait: 'Aguarde',
      address: 'Endereço',
      locationTypes: {
        location: 'Localização',
        inAndOut: 'Dentro e Fora',
        airport: 'Aeroporto',
        facility: 'Instalação',
      },
    },
    radius: {
      title: 'Raio de Correspondência de Endereço',
      toolTipInformation:
        'O raio em metros ou pés (m/ft para métrico/imperial) dentro do qual as reservas são reconhecidas como a localização e/ou como espera e retorno.',
    },
    waitAndReturn: {
      title: 'Esperar E Voltar',
      time: 'Tempo de espera',
      timeDescription: 'A duração em minutos que um motorista esperará entre os trajetos de ida e de volta de uma viagem de espera e ida.',
    },
    advancedSettings: {
      title: 'Configurações Avançadas',
      consistentPassengerRouting: {
        toolTipInformation:
          'Garante que o mesmo grupo de passageiros sempre siga a mesma rota de ida e volta para a instalação, otimizando a eficiência de viagem e minimizando a confusão.',
        title: 'Roteamento Consistente de Passageiros.',
      },
      snapAddressWithinRadius: {
        title: 'Ajustar Endereço Dentro do Raio',
        toolTipInformation:
          'Quando um ponto de recolha/entrega está dentro do raio da localização, ajusta para o nome e coordenadas da localização',
      },
      sameDriverForGroup: {
        toolTipInformation:
          'Atribui o mesmo motorista para transportar o grupo de passageiros tanto na coleta quanto na entrega, proporcionando familiaridade e consistência.',
        title: 'Mesmo Motorista para o Grupo',
      },
      overrideOptions: {
        bySystemSettings: 'Pelas Configurações do Sistema',
        enabled: 'Habilitado',
        disabled: 'Desabilitado',
      },
      allowSharedRide: {
        title: 'Permitir Corrida Compartilhada com Outros Endereços',
        toolTipInformation:
          'Quando ativada, esta configuração permite que corridas compartilhadas sejam agrupadas com reservas de outras localizações que possuem rotas consistentes. Se desativada, apenas corridas da mesma localização serão consideradas para agrupamento.',
      },
      waitForBoardingTime: {
        title: 'Aguardar Tempo de Embarque',
        toolTipInformation: 'Ao chegar em uma parada, o motorista aguardará até o horário exato de embarque, se necessário.',
      },
      tripBoardingTime: {
        title: 'Tempo de Embarque',
        toolTipInformation:
          'O tempo necessário para pegar um passageiro em sua parada (este parâmetro impactará a duração total da viagem).',
      },
      tripDropOffTime: {
        title: 'Tempo de Desembarque',
        toolTipInformation:
          'O tempo necessário para deixar um passageiro em sua parada (este parâmetro impactará a duração total da viagem).',
      },
      maxDropOffEarly: {
        title: 'Máx. Adiantamento de Desembarque',
        toolTipInformation:
          'Número máximo de minutos que um motorista pode chegar adiantado em relação ao horário de desembarque definido na reserva',
      },
      maxDropOffDelay: {
        title: 'Máx. Atraso de Desembarque',
        toolTipInformation:
          'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de desembarque definido na reserva',
      },
      maxBoardingDelay: {
        title: 'Máx. Atraso de Embarque',
        toolTipInformation:
          'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de embarque definido na reserva',
      },
      maxBoardingEarly: {
        title: 'Máx. Adiantamento de Embarque',
        toolTipInformation:
          'Número máximo de minutos que um motorista pode chegar adiantado em relação ao horário de embarque definido na reserva',
      },
      maxTripDuration: {
        title: 'Duração Máxima da Viagem',
        toolTipInformation: 'Duração máxima de uma viagem em minutos',
      },
      maxSinglePassengerTime: {
        title: 'Tempo Máximo de Viagem por Passageiro',
        toolTipInformation: 'Duração máxima de uma viagem em minutos por passageiro',
      },
    },
    advanced: {
      title: 'Avançado',
      addTime: {
        addTimeBtn: 'Adicione tempo',
        name: 'Nome',
        minutes: 'Minutos',
        enterMinutes: 'Inserir minutos',
        enterName: 'Inserir Nome',
      },
    },
    map: {
      title: 'Mapa',
    },
    site: {
      title: 'Local',
    },

    info: {
      subLocations: {
        addSubLocationBtn: 'Adicione Terminal',
        header: 'Terminal',
        fields: {
          subLocation: 'Endereço',
          name: {
            label: 'Nome do endereço',
            placeholder: 'Nome',
          },
        },
      },
    },
  },

  update: {
    confirmButtonText: 'Atualizar',
    formTabs: {
      info: 'Informação',
      advancedSettings: 'Configurações Avançadas',
      history: 'Histórico',
    },

    successToast: {
      message: 'Criado! Localização atualizada com sucesso.',
    },

    errorToast: {
      message: 'Erro. Não foi possível atualizar o local.',
    },
  },

  create: {
    formTabs: {
      info: 'Informação',
      advancedSettings: 'Configurações Avançadas',
    },
    successToast: {
      message: 'Criado! Localização criada com sucesso.',
    },

    errorToast: {
      message: 'Erro. Não foi possível criar localização.',
    },
  },

  delete: {
    successToast: {
      message: 'Excluído! Localização excluída com sucesso.',
    },

    errorToast: {
      message: 'Erro. Não é possível excluir o local.',
    },
  },

  createModal: {
    title: 'Aguardar e retornar',
    body: "Você está prestes a designar este local como um local de 'Aguardar e retornar'. Isso aplicará automaticamente a configuração de 'Aguardar e retornar' a todas as reservas futuras neste local. Tem certeza de que deseja continuar?",
  },
  enableLocationTypeModal: {
    title: 'Aguardar e retornar',
    body: "Você está prestes a ativar a configuração 'Aguardar e retornar'. Isso se aplicará a todas as reservas atuais e futuras que se qualifiquem como 'Aguardar e retornar'. Tem certeza de que deseja continuar?",
  },
  disableLocationTypeModal: {
    title: 'Esperar y regresar',
    body: "Você está prestes a desativar a configuração 'Aguardar e retornar'. Isso a removerá de todas as reservas atuais e futuras identificadas como 'Aguardar e retornar'. Tem certeza de que deseja continuar?",
  },
  deleteLocationTypeModal: {
    title: 'Você está prestes a excluir {{count}} locais.',
    titleAll: 'Você está prestes a excluir todos os locais.',
    body: "Você está prestes a excluir este local como um local de 'Aguardar e retornar'. Isso aplicará automaticamente a configuração de 'Aguardar e retornar' a todas as reservas futuras neste local. Tem certeza de que deseja continuar?",
  },
  updateLocationOfTypeLocationModal: {
    title: 'Esperar y regresar',
    body: "Você está prestes a alterar este local para um local de 'Aguardar e retornar'. Isso aplicará automaticamente a configuração de 'Aguardar e retornar' a todas as reservas futuras neste local. Tem certeza de que deseja continuar?",
  },
};

export default locations;
